import { axios } from 'core/api';
import { apiRoutes } from 'core/api/api.routes';
import { getDataFromResponse, JsonResponse } from 'core/utils/json-response.utils';
import { API, mapSettingsFromApiToVm, VM } from '../domain';

export const getSettings = async (): Promise<VM.Settings> => {
  const response = await axios.get<JsonResponse<API.Settings>>(apiRoutes.settings.get());
  return mapSettingsFromApiToVm(getDataFromResponse(response));
};
